// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wML0","index":"styles_index__2wHtU"};